import { matchRoutes, useLocation } from 'react-router-dom'
import routes from '../routes'

export const useCurrentPattern = () => {
  const location = useLocation()
  const [{ route }] = matchRoutes(routes, location)

  return route.path
}
